import { Location } from '../../models'
import { IStorageObject } from './common'
import { UserProfileModel } from './user'

export enum BookingStatus {
  REQUESTED = 'REQUESTED',
  DECLINED = 'DECLINED',
  PENDING_PAYMENT = 'PENDING_PAYMENT',
  PAYMENT_PROCESSING = 'PAYMENT_PROCESSING',
  PAYMENT_FAILED = 'PAYMENT_FAILED',
  CONFIRMED = 'CONFIRMED',
  CANCELLED = 'CANCELLED',
}

export interface ITransaction {
  id: string
  // TODO: update based on research from square
}

export interface BookingStudioDetails {
  id: string
  title: string
  coverPicture: IStorageObject
  location?: Location
}

export interface BookingUserDetails extends UserProfileModel {
  id: string
}

export interface IBookingModel {
  id: string
  status: BookingStatus
  studio: BookingStudioDetails
  startTime: Date
  endTime: Date
  requester: BookingUserDetails
  host: BookingUserDetails
}

// TODO: Handle booking status
export interface IBooking extends IBookingModel {

}
